export default "__VITE_ASSET__VOS66wud__"